/**
 * File: apps/qbench-cp/reactapp/src/shared/hooks/api/billing.js
 *
 * Purpose: React Query hook for fetching the customer's currency billing setting.
 *
 * Scope: Billing settings used to format prices shown throughout the customer portal.
 *
 * Tags: customer-portal
 *
 * Overview: `useCurrency` fetches the currency configuration from the billing settings
 *     endpoint and returns the response data (defaulting to an empty object) alongside
 *     the underlying react-query result.
 *
 * Exports: useCurrency
 */

import { useQuery } from 'react-query';
import { axiosinstance } from 'shared/utils/api';

const baseUrl = '/v1/billing';

export function useCurrency() {
  const options = {
    url: `${baseUrl}/settings/currency`,
    queryKey: ['billing/settings/currency'],
  };

  const fetchData = () =>
    axiosinstance.get(`${options.url}`).then((res) => res.data);

  const { data, ...queryResult } = useQuery(options.queryKey, fetchData);

  return {
    data: data?.data || {},
    ...queryResult,
  };
}
